<template>
  <div class="box">
    <div class="bread"><bread-list></bread-list></div>
    <div class="article-block d-column" style="padding-bottom: 0">
      <div class="article-list">
        <div class="module j-flex weight">
          <!-- <div v-if="currPrograma != ''" class="fs-xl module-title">
            {{ currPrograma }}
          </div> -->
          <div class="fs-xl module-title" style="margin-bottom: 8px">
            搜索结果
          </div>
        </div>
        <div v-if="searchData.length > 0">
          <li
            class="list-each j-flex fs-sm"
            v-for="item in searchData"
            :key="item.id"
            @click="lookDetail(item)"
          >
            <div class="d-flex title">
              <div class="circle"></div>
              <div class="a-title overflow">{{ item.title }}</div>
            </div>
            <div class="date">{{ item.publishDate | formateDate }}</div>
          </li>
        </div>
        <div v-else class="empty">
          <img src="../../assets/img/emptybox.svg" />
          <div style="margin-top: 4px">未匹配到相关内容</div>
        </div>
      </div>
      <div class="page d-flex fs-md">
        <div class="pageNum">{{ total }}</div>
        条记录 共
        <div class="pageNum">{{ pageNum }}</div>
        页 当前第
        <div class="pageNum">{{ currPage }}</div>
        页
        <button
          class="port-btn"
          :class="{ 'default-btn': currPage == 1 }"
          @click="changeToFirst()"
        >
          首页
        </button>
        <button
          class="changpage-btn"
          :class="{ 'default-btn': currPage == 1 }"
          @click="changeToPrev()"
        >
          上一页
        </button>
        <button
          class="changpage-btn"
          :class="{ 'default-btn': currPage == pageNum }"
          @click="changeToNext()"
        >
          下一页
        </button>
        <button
          class="port-btn"
          :class="{ 'default-btn': currPage == pageNum }"
          @click="changeToLast()"
        >
          末页
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { formateDate } from '../../assets/js/date'
import BreadList from '../../components/BreadList/index.vue'
import navigationData from '../../assets/js/navData'
import { getSearch } from '@/api/api'
export default {
  components: {
    BreadList,
  },
  data() {
    return {
      total: 0,
      pageNum: 0,
      currPage: 1,
      limitNum: 10,
      searchData: [],
      currSearchKey: '',
    }
  },
  filters: {
    formateDate(time) {
      let date = new Date(time)
      return formateDate(date, 'yyyy-MM-dd')
    },
  },
  watch: {
    $route: {
      handler() {
        this.currSearchKey = this.$route.query.search
        this.getSearchList()
      },
    },
  },
  created() {
    this.currSearchKey = this.$route.query.search
    this.getSearchList()
  },
  methods: {
    getSearchList() {
      getSearch(this.currSearchKey, this.currPage, this.limitNum).then(
        (res) => {
          if (res.data.statusCode == 1) {
            this.searchData = res.data.obj.data
            this.total = res.data.obj.count
            this.pageNum = Math.ceil(this.total / this.limitNum)
          }
        }
      )
    },
    changeToFirst() {
      this.currPage = 1
      this.getSearchList()
    },
    changeToPrev() {
      if (this.currPage > 1) {
        this.currPage -= 1
        this.getSearchList()
      }
    },
    changeToNext() {
      if (this.currPage < Math.ceil(this.total / this.limitNum)) {
        this.currPage += 1
        this.getSearchList()
      }
    },
    changeToLast() {
      this.currPage = Math.ceil(this.total / this.limitNum)
      this.getSearchList()
    },
    lookDetail(item) {
      let modelName = ''
      let moduleUrl = ''
      let index = 0
      for (let i = 0; i < navigationData.length; i++) {
        for (let j = 0; j < navigationData[i].child.length; j++) {
          if (navigationData[i].child[j].title == item.category.name) {
            modelName = navigationData[i].name
            moduleUrl = navigationData[i].href
            index = j
          }
        }
      }
      const { href } = this.$router.resolve({
        path: '/article',
        query: {
          one: modelName,
          two: item.category.name,
          three: '详情',
          path: moduleUrl,
          keepalive: index,
          keepchild: 0,
          articleId: item.uuid,
        },
      })
      window.open(href, '_blank')
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/main.scss';
.box {
  width: 100%;
}
.bread {
  width: 1064px;
  margin: 8px auto;
  margin-bottom: -8px;
}
.article-block {
  margin: 16px auto;
  width: 1000px;
  height: 548px;
  background-color: $white;
  padding: 24px 24px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}
.module {
  border-bottom: 1px dashed #000000;
  line-height: 34px;
  padding-bottom: 8px;
  color: $titleFont;
}
.more {
  color: $lightFont;
  cursor: pointer;
}
.article-list {
  width: 100%;
  height: 500px;
  //   margin-left: 24px;
}
.circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: $mainFont;
  margin-right: 8px;
  margin-left: 8px;
}
.list-each {
  list-style: none;
  color: $mainFont;
  line-height: 36px;
  border-bottom: 1px dashed $mainFont;
  cursor: pointer;
  &:hover {
    color: $darkGrenn;
    .circle {
      background-color: $darkGrenn;
    }
  }
}
.title {
  align-items: center;
  width: calc(100% - 100px);
}
.a-title {
  width: calc(100% - 10px);
}
.module-title {
  font-weight: 600;
}
.date {
  color: $lightFont;
}
.page {
  color: #2f2f2f;
  align-items: center;
}
.pageNum {
  color: #007a4d;
  padding-left: 5px;
  padding-right: 5px;
}
.page {
  button {
    margin-left: 14px;
    border: none;
    font-size: 13px;
    border-radius: 2px;
    padding: 2px 4px;
    color: #fff;
    cursor: pointer;
  }
}
.port-btn {
  width: 34px;
  height: 21px;
  background: #66af94;
}
.changpage-btn {
  width: 47px;
  height: 21px;
  background: #007a4d;
}
.default-btn {
  background: #d1d1d1 !important;
}
.empty {
  display: flex;
  justify-content: center;
  margin-top: 52px;
  flex-direction: column;
  align-items: center;
}
</style>
